import Vue from 'vue'
import Router from 'vue-router'

import AppLayout from '../views/layouts/AppLayout'
import LoginPageLayout from '../views/layouts/LoginPageLayout'

import ProjectRoutes from './projects'
import SettingsUsersRoutes from './settings.users'
import SettingsGroupsRoutes from './settings.groups'
import SettingsAcYearsRoutes from './settings.ac-years'
import SettingsFacultiesRoutes from './settings.faculties'
import CheckingRoutes from './checking'
import BudgetRoutes from './budget'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV ? '/e-filing/' : '/',
  routes: [
    {
      path: '/',
      beforeEnter (to, from, next) {
        next({ name: 'projects.index' })
      }
    },
    {
      path: '/start',
      name: 'start',
      component: () => import(/* webpackChunkName: "start" */ '../views/Start.vue'),
      meta: {
        auth: true,
        layout: AppLayout,
        title: 'เลือกระดับสิทธิ์การใช้งาน'
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
      meta: {
        layout: LoginPageLayout
      }
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
      meta: {
        layout: LoginPageLayout,
        bodyClass: 'login-page',
        title: 'เข้าสู่ระบบ'
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import(/* webpackChunkName: "login" */ '../views/PrivacyPolicy.vue'),
      meta: {
        layout: AppLayout,
        title: 'นโยบายคุกกี้'
      }
    }
  ].concat(ProjectRoutes)
    .concat(SettingsUsersRoutes)
    .concat(SettingsGroupsRoutes)
    .concat(SettingsAcYearsRoutes)
    .concat(SettingsFacultiesRoutes)
    .concat(CheckingRoutes)
    .concat(BudgetRoutes)
})

router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the documents (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title + ' - OSDA Event Management System'

  // Remove any stale meta tags from the documents using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  })
  // Add the meta tags to the documents head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router
